export const TOGGLE_LOADING = "TOGGLE_LOADING";

export const SET_USER = "SET_USER";

export const SET_ALERT = "SET_ALERT";

export const TOGGLE_NAVIGATION = "TOGGLE_NAVIGATION";
